export const ImageFormat = {
  SVG: 'SVG',
  PNG: 'PNG',
  PDF: 'PDF',
};
